

(function () {

    function initSplitCarousel(carousel) {

        console.log('Side-by-side carousel JS loaded');

        if (carousel.dataset.initialized === 'true') {
            return;
        }

        carousel.dataset.initialized = 'true';

        const left = carousel.querySelector(
            '[data-carousel-side="left"]'
        );

        const right = carousel.querySelector(
            '[data-carousel-side="right"]'
        );

        if (!left || !right) {
            return;
        }

        const leftSlides = Array.from(
            left.querySelectorAll('[data-carousel-image]')
        );

        const rightSlides = Array.from(
            right.querySelectorAll('[data-carousel-image]')
        );

        if (!leftSlides.length || !rightSlides.length) {
            return;
        }

        const mode = carousel.dataset.playback || 'offset';

        const interval =
            parseInt(carousel.dataset.interval, 10) || 5000;

        let leftIndex = 0;
        let rightIndex = 0;

        function showSlide(slides, index) {

            slides.forEach((slide, slideIndex) => {
                slide.classList.toggle(
                    'is-active',
                    slideIndex === index
                );
            });

        }

        function advanceLeft() {

            if (leftSlides.length < 2) {
                return;
            }

            leftIndex =
                (leftIndex + 1) % leftSlides.length;

            showSlide(leftSlides, leftIndex);
        }

        function advanceRight() {

            if (rightSlides.length < 2) {
                return;
            }

            rightIndex =
                (rightIndex + 1) % rightSlides.length;

            showSlide(rightSlides, rightIndex);
        }

        /*
         * Respect reduced motion.
         */
        const reducedMotion =
            window.matchMedia(
                '(prefers-reduced-motion: reduce)'
            ).matches;

        if (reducedMotion) {
            return;
        }

        if (mode === 'sync') {

            window.setInterval(function () {
                advanceLeft();
                advanceRight();
            }, interval);

        } else {

            /*
             * Left runs on the normal interval.
             */
            window.setInterval(
                advanceLeft,
                interval
            );

            /*
             * Right starts halfway through the interval,
             * then continues at the same speed.
             */
            window.setTimeout(function () {

                advanceRight();

                window.setInterval(
                    advanceRight,
                    interval
                );

            }, interval / 2);

        }

    }


    function initAllSplitCarousels(scope = document) {

        scope
            .querySelectorAll('[data-split-carousel]')
            .forEach(initSplitCarousel);

    }


    document.addEventListener(
        'DOMContentLoaded',
        function () {
            initAllSplitCarousels();
        }
    );


    /*
     * ACF block editor support.
     */
    if (window.acf) {

        window.acf.addAction(
            'render_block_preview/type=filtronic/side-by-side-carousel',
            function ($block) {

                $block
                    .find('[data-split-carousel]')
                    .each(function () {
                        initSplitCarousel(this);
                    });

            }
        );

    }

})();